import { QueryStatus } from '@reduxjs/toolkit/query';
import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';

import { useSaveCurrentSharedTab } from '@/store/sharedWorkspace/useSaveCurrentSharedTab.ts';
import { useSaveWorkspace } from '@/store/workspace/useSaveWorkspace.ts';

type ButtonVariant = 'active' | 'success';

export function SaveSharedTabButton() {
  const [saveSharedTab, { isLoading, status }] = useSaveCurrentSharedTab();
  const { saveWorkspace } = useSaveWorkspace();

  const [variant, setVariant] = useState<ButtonVariant>('active');

  const buttonIcon = variant === 'success' ? 'check_circle' : 'save_as';
  const isButtonDisabled = variant !== 'active';

  const onSuccess = useCallback(() => {
    setVariant('success');
    setTimeout(() => setVariant('active'), 1500);
  }, []);

  const onError = useCallback(() => {
    // TODO: better error managment
    setVariant('active');
  }, []);

  const handleClick = useCallback(() => {
    saveWorkspace();
    saveSharedTab();
  }, [saveSharedTab, saveWorkspace]);

  useEffect(() => {
    if (status === QueryStatus.fulfilled) {
      onSuccess();
    }
    if (status === QueryStatus.rejected) {
      onError();
    }
  }, [status, onSuccess, onError]);

  return (
    <Button
      variant="flat-primary"
      className="btn-lg btn-icon"
      onClick={handleClick}
      disabled={isButtonDisabled}
      data-e2e="save-shared-tab-btn"
    >
      <i className={clsx('icon', { invisible: isLoading, 'text-success': variant === 'success' })}>{buttonIcon}</i>
      {isLoading ? <Spinner size="sm" className="position-absolute" /> : null}
    </Button>
  );
}
